import { Link } from "react-router-dom";
import { Button } from "primereact/button";


const MobileAccountSection = ({
  appUser,
  closeMobileMenu,
  handleOpenLogin,
  handleLogout,
}) => {

  if (!appUser) {
    return (
      <div className="p-3 border-bottom-1 surface-border">
        <Button
          label="Iniciar sesión / Registro"
          icon="pi pi-sign-in"
          onClick={handleOpenLogin}
          className="w-full justify-content-center"
        />
      </div>
    );
  }

  return (
    <div className="p-3 border-bottom-1 surface-border">
      <div className="flex align-items-center gap-2 mb-2">
        <Link to="/mi-cuenta" className="flex align-items-center gap-1 no-underline text-gray-700 text-sm font-medium" onClick={closeMobileMenu}>
          <i className="pi pi-user"></i>
          <span>{appUser}</span>
        </Link>
      </div>
      <div className="flex flex-column gap-1">
        <Link to="/carro" className="flex align-items-center gap-2 no-underline text-gray-700 text-sm w-full py-2" onClick={closeMobileMenu}>
          <i className="pi pi-shopping-cart"></i>
          <span>Carro</span>
        </Link>
        <button type="button" className="flex align-items-center gap-2 text-red-500 text-sm w-full text-left py-2 border-none bg-transparent cursor-pointer" onClick={handleLogout}>
          <i className="pi pi-sign-out"></i>
          <span>Cerrar sesión</span>
        </button>
      </div>
    </div>
  );
};

export default MobileAccountSection;
